/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CaptureEventPayload,
  CaptureEventPayload$Outbound,
  CaptureEventPayload$outboundSchema,
} from "../components/captureeventpayload.js";

export type CaptureEventSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CaptureEventSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CaptureEventSecurityOption3 = {
  chatSessionsTokenHeaderGramChatSession: string;
};

export type CaptureEventSecurity = {
  option1?: CaptureEventSecurityOption1 | undefined;
  option2?: CaptureEventSecurityOption2 | undefined;
  option3?: CaptureEventSecurityOption3 | undefined;
};

export type CaptureEventRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Chat Sessions token header
   */
  gramChatSession?: string | undefined;
  captureEventPayload: CaptureEventPayload;
};

/** @internal */
export type CaptureEventSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CaptureEventSecurityOption1$outboundSchema: z.ZodMiniType<
  CaptureEventSecurityOption1$Outbound,
  CaptureEventSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function captureEventSecurityOption1ToJSON(
  captureEventSecurityOption1: CaptureEventSecurityOption1,
): string {
  return JSON.stringify(
    CaptureEventSecurityOption1$outboundSchema.parse(
      captureEventSecurityOption1,
    ),
  );
}

/** @internal */
export type CaptureEventSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CaptureEventSecurityOption2$outboundSchema: z.ZodMiniType<
  CaptureEventSecurityOption2$Outbound,
  CaptureEventSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function captureEventSecurityOption2ToJSON(
  captureEventSecurityOption2: CaptureEventSecurityOption2,
): string {
  return JSON.stringify(
    CaptureEventSecurityOption2$outboundSchema.parse(
      captureEventSecurityOption2,
    ),
  );
}

/** @internal */
export type CaptureEventSecurityOption3$Outbound = {
  "chat_sessions_token_header_Gram-Chat-Session": string;
};

/** @internal */
export const CaptureEventSecurityOption3$outboundSchema: z.ZodMiniType<
  CaptureEventSecurityOption3$Outbound,
  CaptureEventSecurityOption3
> = z.pipe(
  z.object({
    chatSessionsTokenHeaderGramChatSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      chatSessionsTokenHeaderGramChatSession:
        "chat_sessions_token_header_Gram-Chat-Session",
    });
  }),
);

export function captureEventSecurityOption3ToJSON(
  captureEventSecurityOption3: CaptureEventSecurityOption3,
): string {
  return JSON.stringify(
    CaptureEventSecurityOption3$outboundSchema.parse(
      captureEventSecurityOption3,
    ),
  );
}

/** @internal */
export type CaptureEventSecurity$Outbound = {
  Option1?: CaptureEventSecurityOption1$Outbound | undefined;
  Option2?: CaptureEventSecurityOption2$Outbound | undefined;
  Option3?: CaptureEventSecurityOption3$Outbound | undefined;
};

/** @internal */
export const CaptureEventSecurity$outboundSchema: z.ZodMiniType<
  CaptureEventSecurity$Outbound,
  CaptureEventSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CaptureEventSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CaptureEventSecurityOption2$outboundSchema),
    ),
    option3: z.optional(
      z.lazy(() => CaptureEventSecurityOption3$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
      option3: "Option3",
    });
  }),
);

export function captureEventSecurityToJSON(
  captureEventSecurity: CaptureEventSecurity,
): string {
  return JSON.stringify(
    CaptureEventSecurity$outboundSchema.parse(captureEventSecurity),
  );
}

/** @internal */
export type CaptureEventRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Chat-Session"?: string | undefined;
  CaptureEventPayload: CaptureEventPayload$Outbound;
};

/** @internal */
export const CaptureEventRequest$outboundSchema: z.ZodMiniType<
  CaptureEventRequest$Outbound,
  CaptureEventRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramChatSession: z.optional(z.string()),
    captureEventPayload: CaptureEventPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      gramChatSession: "Gram-Chat-Session",
      captureEventPayload: "CaptureEventPayload",
    });
  }),
);

export function captureEventRequestToJSON(
  captureEventRequest: CaptureEventRequest,
): string {
  return JSON.stringify(
    CaptureEventRequest$outboundSchema.parse(captureEventRequest),
  );
}
